export enum ADPLRNAEnum {
    L = 1,      // Left
    R = 2,      // Right
    NA = 3      // N/A
}
